import { apiPathFunc } from "@api/util/apiPathFunc";

import type { IExtractParams } from "@routes";

const pathBase = `/payment-methods/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const paymentMethods = {
  getAll: apiPathFunc(pathBase),
} as const;
